import { supabase } from '../client';
import type { Database } from '../generated';

export type OrgModuleFlag = Database['core']['Tables']['org_module_flags']['Row'];

export async function listOrgModuleFlags(orgId: string): Promise<OrgModuleFlag[]> {
  const { data, error } = await supabase()
    .schema('core')
    .from('org_module_flags')
    .select('*')
    .eq('org_id', orgId)
    .limit(200);
  if (error) throw error;
  return data ?? [];
}

export interface ModuleFlagMap {
  isEnabled(moduleId: string): boolean;
  raw: ReadonlyArray<OrgModuleFlag>;
}

/**
 * Loads the per-org module flag map. Modules NOT present in the table are
 * treated as enabled by default -- a newly registered module becomes visible
 * to existing orgs without a data migration. Disabling is explicit: insert a
 * row with `enabled = false`.
 */
export async function loadModuleFlagMap(orgId: string): Promise<ModuleFlagMap> {
  const raw = await listOrgModuleFlags(orgId);
  const disabled = new Set(raw.filter((f) => !f.enabled).map((f) => f.module_id));
  return {
    raw,
    isEnabled(moduleId: string) {
      return !disabled.has(moduleId);
    },
  };
}
